import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";

import { useApi } from "../../../context/api.js";

function WordSearch({ onAdd, words }) {
  const api = useApi();
  const timers = useRef();

  const [wordsLoading, setWordsLoading] = useState(false);
  const [wordsChoices, setWordsChoices] = useState([]);
  const [wordInput, setWordInput] = React.useState("");

  const searchWord = (event, newInputValue, reason) => {
    if (reason === "input") {
      setWordInput(newInputValue);

      if (timers.wordSearch) {
        clearTimeout(timers.wordSearch);
      }

      if (newInputValue) {
        setWordsLoading(true);

        timers.wordSearch = setTimeout(() => {
          api.suggestWords(newInputValue).then((words) => {
            setWordsChoices(words);
            setWordsLoading(false);
          });
        }, 500);
      } else {
        setWordsChoices([]);
      }
    } else if (reason === "reset") {
      setWordInput("");
    }
  };

  return (
    <Autocomplete
      disableClearable
      clearOnBlur
      //disableCloseOnSelect
      selectOnFocus
      id="word-search"
      value={""}
      onChange={(event, newValue) => {
        onAdd(newValue);
        setWordInput("");
      }}
      inputValue={wordInput}
      onInputChange={searchWord}
      options={wordsChoices}
      getOptionDisabled={(w) => words.includes(w)}
      loading={wordsLoading}
      loadingText="Recherche..."
      noOptionsText={
        wordInput && !wordsLoading
          ? "Pas de résultat."
          : "Saisissez quelques caractères pour rechercher un mot."
      }
      fullWidth
      sx={{ mt: 1 }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Rechercher/ajouter un mot"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {wordsLoading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
          onKeyUp={(e) => {
            if (e.keyCode === 13 && wordInput) {
              onAdd(wordInput);
              setWordsChoices([]);
              setWordInput("");
            }
          }}
        />
      )}
    />
  );
}

WordSearch.propTypes = {
  onAdd: PropTypes.func.isRequired,
  words: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default WordSearch;
